import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { OwlOptions, SlidesOutputData, CarouselModule } from 'ngx-owl-carousel-o';
import { OnboardingService } from '../../../services';
import { Observable } from 'rxjs';
import { OnboardingItem } from '@nx-customer-apps/shared/interfaces';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { ComponentsModule } from '@nx-customer-apps/components';

@Component({
    selector: 'vp-onboarding',
    templateUrl: './onboarding.component.html',
    styleUrl: './onboarding.component.scss',
    imports: [
        ComponentsModule,
        CdkScrollable,
        MatDialogContent,
        CarouselModule,
        MatDialogActions,
        NgTemplateOutlet,
        MatButton,
        AsyncPipe,
        TranslatePipe
    ]
})
export class OnboardingComponent implements OnInit {
    public dialogRef = inject<MatDialogRef<OnboardingComponent>>(MatDialogRef);
    private onboarding = inject(OnboardingService);

    public selectedSlideIndex: number = 0;
    public FAQUrl$: Observable<string>;
    public allSlides: OnboardingItem[];

    public ngOnInit() {
        this.setFAQUrl();
        this.setSlides();
    }

    public readonly carouselOptions: OwlOptions = {
        touchDrag: true,
        dots: true,
        navSpeed: 700,
        responsive: {
            0: {
                items: 1
            }
        },
        nav: false
    };

    // TODO: Add unit tests
    public onClose(): void {
        this.dialogRef.close({ close: true });
    }

    public setSelectedSlide(change: SlidesOutputData) {
        this.selectedSlideIndex = change.startPosition as number;
    }

    public setFAQUrl() {
        this.FAQUrl$ = this.onboarding.getFAQUrl$();
    }

    public setSlides() {
        this.allSlides = this.onboarding.getSlides();
    }

    public isFirstSlide() {
        return this.selectedSlideIndex === 0;
    }

    public isLastSlide() {
        return this.selectedSlideIndex === this.allSlides.length - 1;
    }
}
